module.exports = __webpack_public_path__ + "img/offline_mtg.6bc24f95.svg";